import { isFailure } from "@sportal/api";
import { ReportSlice } from "@sportal/api/reports";

import { fetchReport } from "../../reports.actions";
import {
  LOAD_WIDGET,
  LOAD_WIDGET_FAILURE,
  LOAD_WIDGET_SUCCESS,
  WidgetActionTypes,
} from "./widgets.types";
import {
  DataKeys,
  ReportsPeriod,
} from "../../../../helpers/reports.helper.types";
import { SBThunkAction } from "../../../redux.types";

export const loadWidgetReport =
  (
    endpoint: DataKeys,
    options: { period: ReportsPeriod }
  ): SBThunkAction<void, WidgetActionTypes> =>
  (dispatch) => {
    dispatch(
      async () => {
        const id = endpoint;
        dispatch(loadWidget({ id, period: options.period }));

        const result = await dispatch(fetchReport(endpoint, options, "get"), {
          showLoader: false,
        });

        if (isFailure(result)) {
          dispatch(
            loadWidgetFailure({
              id,
              error: result.error,
              period: options.period,
            })
          );
          return;
        }

        dispatch(
          loadWidgetSuccess({ id, data: result.data, period: options.period })
        );
      },
      { showLoader: false }
    );
  };

const loadWidget = ({
  id,
  period,
}: {
  id: DataKeys;
  period: any;
}): WidgetActionTypes => ({
  type: LOAD_WIDGET,
  payload: { id, period },
});

const loadWidgetSuccess = ({
  id,
  data,
  period,
}: {
  id: DataKeys;
  data: ReportSlice[];
  period: any;
}): WidgetActionTypes => ({
  type: LOAD_WIDGET_SUCCESS,
  payload: { id, data, period },
});

const loadWidgetFailure = ({
  id,
  error,
  period,
}: {
  id: DataKeys;
  error: any;
  period: any;
}): WidgetActionTypes => ({
  type: LOAD_WIDGET_FAILURE,
  payload: { id, error, period },
});
